import React, { useEffect } from 'react';
import './Settings.scss';
import { connect } from 'react-redux';
import { setScreen, setFilter } from '../../../redux/actions';
import NavBar from './NavBar/NavBar';
import Filter from './Filter/Filter';
import VendorList from './VendorList/VendorList';

const Settings = props => {

    const { setFilter } = props;

    useEffect(() => {
        setFilter({
            filterName: 'purposes',
            value: props.currentLanguage.vendorList.purposes[0]
        });
    }, [setFilter, props.currentLanguage.vendorList.purposes]);

    return (
        <div id="settings">
            <NavBar />
            <div id="vendorlist__container" className="row container">
                <div className="col-2">
                    <Filter />                    
                </div>
                <div className="col-10 border-left">
                    <div id="vendorContainer">
                        <div id="vendorlistInformation">
                            <h2>{props.currentFilter ? props.currentFilter.value.name : null}</h2>
                            <div className="pre">{props.currentFilter ? props.currentFilter.value.descriptionLegal : null}</div>
                        </div>
                        <VendorList />
                        {!props.currentFilter ? (<p>No filter selected.</p>) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStatetoProps = state => {
    return {...state};
};

export default connect(mapStatetoProps, {setScreen, setFilter})(Settings);